import { ButtonFinal } from "@kalyzee/escaet-ui";
import { AppVersion } from "@kalyzee/kast-web-sdk/web-components";
import { useLogger } from "../../../helpers/logger";
import styles from "./logout.module.css";
import { useAuthContext } from "@kalyzee/kast-web-sdk";
import { MasterUI } from "../../../components/common/MasterUI";

const LogoutPage = () => {
  const logger = useLogger();

  const { logout } = useAuthContext();

  const onLogout = () => {
    logger.log("[LOGOUT] : on logout button press");
    logout();
  };

  return (
    <MasterUI>
      <div className={styles.container}>
        <div style={{ minWidth: "200px" }}>
          <ButtonFinal
            text="Se déconnecter"
            background="#4b4b4b"
            cx="!text-white !py-[20px] !w-full !rounded-[10px] !font-bold !text-[16px]"
            onClick={onLogout}
          />
        </div>
        <AppVersion />
      </div>
    </MasterUI>
  );
};

export default LogoutPage;
